import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'streamLogs';
export const useStreamLogsTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Логи',
    modal_title: 'Логи видеоаналитик источника',
    filters: {
      date_from: 'Дата начала',
      date_to: 'Дата окончания',
      status: 'Статус видеоаналитики',
    },
    details: 'Детали',
    copy: 'Копировать',
    empty: 'Нет логов',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Logs',
    modal_title: 'Source analytics logs',
    filters: {
      date_from: 'Start date',
      date_to: 'End date',
      status: 'Analytics status',
    },
    details: 'Details',
    copy: 'Copy',
    empty: 'No logs',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Registros',
    modal_title: 'Registros de videoanalíticas de la fuente',
    filters: {
      date_from: 'Fecha de inicio',
      date_to: 'Fecha de fin',
      status: 'Estado de la videoanalítica',
    },
    details: 'Detalles',
    copy: 'Copiar',
    empty: 'Sin registros',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Registros',
    modal_title: 'Registros das análises de vídeo da fonte',
    filters: {
      date_from: 'Data inicial',
      date_to: 'Data final',
      status: 'Status da análise',
    },
    details: 'Detalhes',
    copy: 'Copiar',
    empty: 'Sem registros',
  },
}) : {}) as Record<string, unknown>;
